<template>
    <g clip-path="url(#clip0_840_5214)">
        <path
            d="M3.26354 6.04941C3.43232 6.05011 3.59381 6.11833 3.71195 6.23888L6.83828 9.36519L9.9646 6.23888C10.2524 6.04175 10.6455 6.11521 10.8426 6.40298C10.9853 6.61128 10.9902 6.88453 10.8551 7.09783L7.2867 10.6726C7.04107 10.9202 6.64118 10.9219 6.39351 10.6762C6.39228 10.675 6.39106 10.6738 6.38985 10.6726L2.82145 7.09783C2.57656 6.8515 2.57656 6.45364 2.82145 6.20731C2.94305 6.09982 3.10137 6.04329 3.26354 6.04941Z"
            fill="#727EA3"
        />
        <path
            d="M6.83912 0.781455C7.18793 0.781455 7.4707 1.06423 7.4707 1.41304L7.4707 10.2551C7.4707 10.6039 7.18793 10.8867 6.83912 10.8867C6.49031 10.8867 6.20753 10.6039 6.20753 10.2551L6.20753 1.41304C6.20753 1.06423 6.49031 0.781455 6.83912 0.781455Z"
            fill="#727EA3"
        />
        <path
            d="M3.04924 11.5181L10.6282 11.5181C10.977 11.5181 11.2598 11.8009 11.2598 12.1497C11.2598 12.4985 10.977 12.7812 10.6282 12.7812L3.04924 12.7813C2.70043 12.7813 2.41765 12.4985 2.41765 12.1497C2.41765 11.8009 2.70043 11.5181 3.04924 11.5181Z"
            fill="#727EA3"
        />
    </g>
    <defs>
        <clipPath id="clip0_840_5214">
            <rect width="12" height="12" fill="white" transform="matrix(-1 0 0 -1 12.8379 12.7812)" />
        </clipPath>
    </defs>
</template>
